// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"192248c2","4274":"2f889ab3"}[chunkId] + ".chunk.css";
};